import React from 'react';
import { checkSetState, changeState } from '@teammo/teammo-general-utils';
import history from 'app/routes/history';
import IActions from 'app/types/actions';
import { IClubsSelector, IOrganisationsSelector } from 'app/types/selector';
import { sports } from 'app/utils/static/sports';
import { Form } from 'reactstrap';
import HeaderThin from 'app/components/layout/HeaderThin';
import Button from 'app/components/general/Button';
import InputGroupBlock from 'app/components/general/InputGroupBlock';
import SectionGroup from 'app/components/general/SectionGroup';
import OrganisationIcon from 'app/images/icons/organisation.svg';
import SportIcon from 'app/images/icons/sport.svg';
import validateInput from './CreateClubValidator';

interface ICreateClubProps {
  actions: IActions;
  clubs: IClubsSelector;
  name: string;
  sport: string;
  organisations: IOrganisationsSelector;
  organisation: any;
  isLoading: boolean;
  errors: any;
}
interface ICreateClubState {
  name: string;
  sport: string;
  organisation: any;
  listSports: any;
  errors: any;
}

export default class CreateClub extends React.Component<
  ICreateClubProps,
  ICreateClubState
> {
  static defaultProps = {
    actions: undefined,
    name: undefined,
    sport: undefined,
    organisations: {},
    clubs: {},
    organisation: undefined,
    isLoading: false,
    errors: undefined,
  };

  readonly state: ICreateClubState = {
    name: this.props.name || '',
    sport: this.props.sport || undefined,
    organisation: this.props.organisation || '',
    listSports: sports,
    errors: {},
  };

  async componentDidMount(): Promise<void> {
    if (
      !this.props.organisations.isLoading
      && !this.props.organisations.hasLoaded
      && this.props.actions.getAllOrganisations
    ) {
      await this.props.actions.getAllOrganisations();
    }
  }

  // UNSAFE_componentWillReceiveProps(newProps): void {
  //   console.log(newProps);
  //   // this.setState(checkSetState(this.props, newProps));
  // }

  handleCancel = (e): void => {
    e.preventDefault();
    if (this.props.clubs.clubIds.length === 0) {
      history.push('/dashboard');
    } else {
      history.push('/clubs');
    }
  };

  handleOrganisationChange = (e): void => {
    delete this.state.errors.organisation;
    if (e && e != null) {
      this.setState({ organisation: e });
    }
  };

  handleChange = (e): void => {
    e.persist();
    this.setState((previousState) => changeState(previousState, e.target));
  };

  handleSport = (e): void => {
    if (e && e != null) {
      this.setState({ sport: e });
    }
  };

  handleSubmit = (e): void => {
    e.preventDefault();
    if (this.isValid()) {
      this.props.actions.createClub({
        name: this.state.name,
        sport: this.state.sport,
        organisation: {
          id: this.state.organisation,
        },
      });
    }
  };

  isValid(): boolean {
    const { errors, isValid } = validateInput(this.state);

    if (!isValid) {
      this.setState({ errors });
    }

    return isValid;
  }

  render(): React.ReactNode {
    return (
      <div>
        <div className="row">
          <div className="col">
            <HeaderThin title="Clubs" divider />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <SectionGroup title="Create your club">
              <Form>
                <div className="row">
                  <div className="col col-12">
                    <InputGroupBlock
                      name="name"
                      labelText="Club Name"
                      placeholder="Club name"
                      errors={this.state.errors}
                      value={this.state.name}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col col-12">
                    <InputGroupBlock
                      icon={SportIcon}
                      name="sport"
                      labelText="Sport"
                      placeholder="Sport"
                      type="select"
                      errors={this.state.errors}
                      value={this.state.sport}
                      options={this.state.listSports}
                      createable
                      onChange={this.handleSport}
                    />
                  </div>
                  {/* <div className="col col-12">
                    <InputGroupBlock
                      type="select"
                      icon={OrganisationIcon}
                      labelText="Sports organisation / league (Optional)"
                      name="organisation"
                      placeholder="Sports organisation/league"
                      aria-label="Sports organisation/league"
                      autoComplete="off"
                      value={this.state.organisation}
                      options={
                        this.props.organisations.organisationsByIdInSelectFormat
                      }
                      onChange={this.handleOrganisationChange}
                    />
                  </div> */}
                </div>
                <div className="row with-margin-top-10">
                  <div className="col btn-flex-group">
                    <div className="btn-flex-container thin-margin">
                      <Button
                        className="btn-success"
                        isLoading={this.props.isLoading}
                        disabled={!this.state.name || !this.state.sport}
                        onClick={this.handleSubmit}
                      >
                        Create Club
                      </Button>
                    </div>
                  </div>
                </div>
              </Form>
            </SectionGroup>
          </div>
        </div>
      </div>
    );
  }
}
